var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRss = function SvgRss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1177.3 1177.3"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168.2,
    cy: 1009.1,
    r: 168.2,
    transform: "rotate(-45.001 168.192 1009.077)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 392.4v224.3c309.1 0 560.6 251.4 560.6 560.6h224.2c0-432.7-352.1-784.8-784.8-784.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v224.2c525.6 0 953.1 427.4 953.1 953.1h224.2C1177.3 528.1 649.2 0 0 0"
  })));
};
export default SvgRss;